module.exports = __webpack_public_path__ + "img/y.ff076258.jpg";